import { render, staticRenderFns } from "./TrackerProjectEdit.vue?vue&type=template&id=56b098c9&scoped=true&"
import script from "./TrackerProjectEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./TrackerProjectEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b098c9",
  null
  
)

export default component.exports